<!-- =========================================================================================
    File Name: ProjectsWorkerSidebar.vue
    Description: Email Application Sidebar(Filter) (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="email__email-sidebar h-full">
        <div class="m-6 clearfix flex">
          <h4> Projects </h4>
          <vs-button style="margin-left: auto; margin-top: -3px;" radius icon="refresh" @click="GetProjects()" size="small"></vs-button>
        </div>


        <VuePerfectScrollbar :is="scrollbarTag" class="email-filter-scroll-area" :settings="settings" :key="$vs.rtl">
            <div class="px-6 pb-2 flex flex-col">
                <ul class="centerx">
                     <!-- <v-select :options="projectClientList" :reduce="x => x.ClientID" label="ClientName" v-model="clientIDFilter" placeholder="Client" class="mt-2" :default="null"/> -->
                    <!-- <v-select :options="workerList" :reduce="x => x.WorkerID" label="WorkerName" v-model="workerIDFilter" placeholder="Worker" class="mt-2" :default="null"/> -->

                      <div class="mb-5">
                        <div v-if="isAdmin">
                          <!-- <vs-button class="mb-10" v-if="syncing == false" size="small" style="width: 100%;" color="warning" icon="link" @click="SyncAllProjectsFromJira()">Sync All From Jira</vs-button>
                          <div v-else>
                            <vs-progress :percent="syncingProgress" color="warning"></vs-progress>
                            <span style="font-size: 12px;"> Syncing: </span> <span>{{syncingName}}</span>
                          </div> -->
                          
                        </div>
                        <div class="flex mt-5">
                          <div style="margin-top:11px;" class="mr-3">Filter:</div>
                          <vs-avatar text="ALL" v-if="GetWorkerFromID(workerIDFilter2) == null" color="danger"/> 
                          <vs-avatar v-else :src="GetWorkerFromID(workerIDFilter2).WorkerAvatar" color="danger" /> 

                          <vs-avatar text="ALL" v-if="clientIDFilter2 == null" color="primary"/> 
                          <vs-avatar v-else :src="(GetClientFromID(clientIDFilter2) || {}).ClientAvatar" /> 
                        </div>
                        <vs-button @click="showFilters = true" size="small" class="mt-2 w-full"> Show Visibility Filters</vs-button>

                      </div>

                      <!-- <vs-button v-if="isAdmin" size="small" style="width:100%;" class="mt-2 mb-4" icon="add" @click="CreateProject">Create</vs-button> -->
                      
                  <div :data="project" :key="index" v-for="(project, index) in DisplayedProjectList()" class="my-4">
                    <li>
                      <vs-radio v-model="radios" :vs-value="project.ITATInfo.ProjectID" vs-name="radios"> 
                        <div><h6>{{project.JiraInfo.name}}</h6></div> 
                        <div>{{clientNameFromID(project.ITATInfo.ClientID)}}</div> 
                        <vs-alert v-if="project.ITATInfo.CategoryID == null" color="danger" class="missingCategory">Missing Category!</vs-alert>
                      </vs-radio>
                    </li>
                  </div>
                </ul>

                <!-- <vs-list>
                  <vs-list-header title="Project List" color="primary"></vs-list-header>

                  <draggable :list="DisplayedProjectList()" group="people" class="p-1 cursor-move">
                    <transition-group>
                      <vs-list-item class="list-item" v-for="(project, index) in DisplayedProjectList()" :key="project.ProjectID" :title="clientNameFromID(project.ClientID)" :subtitle="project.ProjectName">
                        <vs-radio class="pl-3" v-model="radios" :vs-value="project.ProjectID" vs-name="radios"> 
                        </vs-radio>
                      </vs-list-item>
                    </transition-group>
                  </draggable>

                </vs-list> -->

            </div>
        </VuePerfectScrollbar>
        <vs-prompt :active.sync="showFilters" title="Filters">
          <vs-checkbox v-model="filterCheckbox" vs-value="0">0 - Current</vs-checkbox>
          <vs-checkbox v-model="filterCheckbox" vs-value="1" class="mt-2">1 - Pending</vs-checkbox>
          <vs-checkbox v-model="filterCheckbox" vs-value="2" class="mt-2">2 - Specifications</vs-checkbox>
          <vs-checkbox v-model="filterCheckbox" vs-value="3" class="mt-2">3 - In Queue</vs-checkbox>
          <vs-checkbox v-model="filterCheckbox" vs-value="4" class="mt-2">4 - New</vs-checkbox>
          <vs-checkbox v-model="filterCheckbox" vs-value="5" class="mt-2">5 - Internal</vs-checkbox>
          <vs-checkbox v-model="filterCheckbox" vs-value="9" class="mt-2">9 - Inactive</vs-checkbox>
        </vs-prompt>
    </div>
</template>

<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import draggable from 'vuedraggable'

export default {
  props:{
    clientIDFilter2 : {  required: true   },
    workerIDFilter2 : {  required: true   }
  },
  data () {
    return {
      clientIDFilter: null,
      workerIDFilter: null,
      radios:-1,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30
      },
      syncing: false,
      syncingName: "",
      syncingProgress: 0,
      filterCheckbox: ["0","1","2","3","4","5"],
      showFilters: false
    }
  },
  watch: {
    workerIDFilter2 (val) {
      this.FilterProjects()
    },
    clientIDFilter2 (val) {
      this.clientIDFilter = val
      this.FilterProjects()
    },
    radios (radio) {
      console.log(radio)
      this.SetSelectedProjectID()
    },
    projectList (s) {
      this.FilterProjects()
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    workerList () {
      return this.$store.getters.GetWorkerList
    },
    projectClientList () {
      const clients = []
      const clientIDS = []
      for (let i = 0; i < this.projectList.length; i++) {
        const client = this.GetClientFromID(this.projectList[i].ITATInfo.ClientID)
        if (client == null) continue
        if (clientIDS.indexOf(client.ClientID) == -1) {
          clients.push({'ClientID': client.ClientID, 'ClientAvatar': client.ClientAvatar, 'ClientName': client.ClientName})
          clientIDS.push(client.ClientID)
        }
      }
      return clients
    },
    taskList() {
      return this.$store.getters.GetTaskList
    },
    projectList() {
      let l = this.$store.getters.GetProjectList
      if (this.workerIDFilter2 != null) l = l.filter(x => this.ProjectWorkerList(x.ITATInfo.ProjectID).indexOf(this.workerIDFilter2) != -1)
      return l
    },
    clientList() {
      return this.$store.getters.GetClientList
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    }
  },
  methods: {
    ProjectWorkerList(projectID){
      var workerList = []
      for(var i = 0; i < this.taskList.length; i++){
        var task = this.taskList[i]
        if(task.ITATInfo.ProjectID == projectID){
          for(var w = 0; w < task.ITATInfo.TaskWorkers.length; w++){
            var ww = task.ITATInfo.TaskWorkers[w]
            if(workerList.indexOf(ww) == -1){
              workerList.push(ww)
            }
          }
        }
      }
      return workerList
    },
    FilterProjects(){
      console.log("Filter Projects")
      console.log("ClientIDFilter", this.clientIDFilter2)
      var v = []
      if (this.clientIDFilter2 != null) {
        v = this.projectList.filter(x => x.ITATInfo.ProjectWorkers.indexOf(this.clientIDFilter2) != -1)
        console.log("Filtered", v)
      } else {
        v = this.projectList
      }
      if (v.length > 0) {
        this.radios = v[0].ProjectID
      }
    },
    async SyncAllProjectsFromJira() {
      console.log("SyncAllProjectsFromJira")
      this.syncing = true
      this.syncing = false
    },
    GetProjects(){
      return Promise.resolve()
    },
    CreateProject () {
      this.$emit('ChildCreateProject', this.task)   
    },
    GetWorkerFromID (workerID) {
      return this.workerList.find(x => x.WorkerID === workerID) || null
    },
    GetClientFromID (clientID) {
      return this.clientList.find(x => x.ClientID == clientID) || null
    },
    DisplayedProjectList () {
      let list = JSON.parse(JSON.stringify(this.projectList))
      if (this.clientIDFilter != null) {
        list = list.filter(x => (x.ITATInfo && x.ITATInfo.ClientID === this.clientIDFilter) || x.ClientID === this.clientIDFilter)
      }
      list.sort(function(a, b) {
          var textA = a.JiraInfo.name.toUpperCase();
          var textB = b.JiraInfo.name.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      });
      
      
      //list = list.sort((a,b) => x.JiraInfo.name > b.JiraInfo.name ? 1 : -1)
      return list.filter(x => this.filterCheckbox.indexOf(x.JiraInfo.name.substring(0, 1)) != -1)
    },
    OnChangedClient () {

    },
    clientNameFromID (id) {
      for (let i = 0; i < this.clientList.length; i++) {
        if (this.clientList[i].ClientID == id) {
          return this.clientList[i].ClientName
        }
      }
    },
    SetSelectedProjectID () {
      const proj = this.projectList.find(x => x.ITATInfo.ProjectID == this.radios)
      if (proj == null) return null

      console.log(proj)
      this.$store.commit('SetSelectedProjectID', proj.JiraInfo.id)
      // this.$store.dispatch('ActionFetchProjectTasks', [proj.JiraInfo.id, proj.ITATInfo.ProjectID])
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    draggable
  },
  mounted () {
    // this.SetSelectedProjectID()
  }
}

</script>


<style lang="css">
.missingCategory{
  padding: 3px !important;
  height: 22px !important;
  margin-top: 2px !important;
}

.missingCategory > .vs-alert{
  padding: 2px !important;
}
</style>